import { AccountReceivableModel } from 'api-hooks/account-receivable';
import { PaymentMethodEnum } from 'api-hooks/payment-channel';
import HOCInput from 'components/common/hoc-input';
import { FormState, Input } from 'components/elements';
import BankAccountSelectInput from 'legacy-modules/master/bank-account/components/select-input';
import CashAccountSelectInput from 'legacy-modules/master/cash-account/components/select-input';
import ChequeGiroSelectInput from 'legacy-modules/master/cheque-giro/components/select-input';
import PaymentMethodSelectInput from 'legacy-modules/master/select-input/payment-method-select-input';
import useTranslation from 'next-translate/useTranslation';
import { useFormContext } from 'react-hook-form';

interface Props {
  accountReceivable?: AccountReceivableModel;
}

export default function PaymentField(props: Props) {
  const { t } = useTranslation();
  const { setValue, getValues } = useFormContext();
  const { accountReceivable } = props;

  return (
    <>
      <FormState>
        {({ editable }) => (
          <PaymentMethodSelectInput
            name="paymentMethodId"
            label={t('debt:payment_method')}
            placeholder={t('debt:payment_method')}
            onAfterChange={(params) => {
              const value = params?.option;
              if (editable) {
                setValue('chequeNote', null);
                const customerId = getValues('customerId');
                switch (value?.type) {
                  case PaymentMethodEnum.Balance:
                    setValue('paymentableId', customerId);
                    break;
                  default:
                    setValue('paymentableId', null);
                    break;
                }
              }
              if (params) {
                setValue('paymentMethod', value?.type);
                setValue('paymentMethodId', value?.id);
              }
            }}
            required
            disabled={!!accountReceivable}
          />
        )}
      </FormState>

      <HOCInput keys={['paymentMethod']}>
        {(values) => {
          switch (values.paymentMethod) {
            case PaymentMethodEnum.ChequeGiro:
              return (
                <>
                  <ChequeGiroSelectInput
                    name="chequeNote.chequeGiroId"
                    required
                    onAfterDetailChange={({ id }) => {
                      setValue('chequeNote.chequeGiroId', id);
                      setValue('paymentableId', id);
                    }}
                  />
                  <Input
                    type="text"
                    name="chequeNote.referenceNumber"
                    label={t('debt:reference_number')}
                    placeholder={t('debt:reference_number')}
                    required
                  />
                  <Input
                    type="date-time"
                    name="chequeNote.issuedAt"
                    label={t('debt:issued_at')}
                    placeholder={t('debt:issued_at')}
                    required
                  />
                  <Input
                    type="date-time"
                    name="chequeNote.availableAt"
                    label={t('debt:available_at')}
                    placeholder={t('debt:available_at')}
                    required
                  />
                  <Input
                    type="date-time"
                    name="chequeNote.expiredAt"
                    label={t('debt:expiry_at')}
                    placeholder={t('debt:expiry_at')}
                    required
                  />
                  <BankAccountSelectInput
                    name="chequeNote.bankAccountId"
                    required
                  />
                </>
              );
            case PaymentMethodEnum.Bank:
              return <BankAccountSelectInput name="paymentableId" required />;
            case PaymentMethodEnum.Cash:
              return <CashAccountSelectInput name="paymentableId" />;
            default:
              return <></>;
          }
        }}
      </HOCInput>
    </>
  );
}
